import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PLAN_NAMES = {
  trial: "Launch Trial",
  starter: "Starter Scale",
  growth: "Growth Pro",
  empire: "Empire Velocity",
  custom: "Custom Volume",
};

// The studio's production pipeline — exactly the backend's status flow.
export const STATUS_FLOW = ["Submitted", "In Production", "QC Check", "Delivered"];
export const STAGE_META = {
  Submitted: { step: "Brief received", chip: "border-white/15 bg-white/5 text-slate-300" },
  "In Production": { step: "In production", chip: "border-sky-400/40 bg-sky-400/10 text-sky-300" },
  "QC Check": { step: "Quality check", chip: "border-amber-400/40 bg-amber-400/10 text-amber-300" },
  Delivered: { step: "Ready", chip: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300" },
};

export const NICHE_OPTIONS = [
  "Teacher", "Mom / Family", "Pets", "Sports", "Western", "Fishing", "Hunting",
  "Fitness", "Faith", "Patriotic", "Wedding", "Baby", "Grandma / Family Titles",
  "Profession", "Seasonal", "Funny / Sarcastic", "Retro", "Coquette", "Minimalist", "Custom / Other",
];
export const THEME_OPTIONS = [
  "Halloween", "Christmas", "Fall / Autumn", "Summer", "Spring", "Valentine's Day",
  "Back to School", "Fourth of July", "Evergreen / Year-Round", "St. Patrick's Day",
  "Easter", "Mother's Day", "Father's Day", "Graduation", "Thanksgiving",
];
export const STYLE_PRESETS = [
  "Bold Retro", "Minimalist", "Watercolor", "Hand-drawn", "Vintage Distressed",
  "Playful Cartoon", "Elegant Script", "Photorealistic",
];

export const inputCls =
  "w-full rounded-xl border border-white/10 bg-[#070B14]/80 px-4 py-3.5 text-sm text-slate-100 placeholder:text-slate-600 focus:border-sky-400/60 focus:outline-none focus:ring-2 focus:ring-sky-400/20";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function fetchDashboard(email) {
  const { data } = await axios.post(`${API}/dashboard`, { email });
  return data;
}

export function stageOf(status) {
  return Math.max(0, STATUS_FLOW.indexOf(status));
}

// "jane.doe92@..." → "Jane Doe" — a friendly name from the account email.
export function firstNameFromEmail(email) {
  if (!email) return "there";
  const local = email.split("@")[0].replace(/[0-9]+/g, "");
  const parts = local.split(/[._-]+/).filter(Boolean).slice(0, 2);
  const name = parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(" ");
  return name || "there";
}

export function shortDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function shortDateTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

// Creative Preferences live locally and prefill the New Brief style field.
export function getStylePrefs() {
  try {
    return JSON.parse(localStorage.getItem("grapho_style_prefs") || "[]");
  } catch (e) {
    return [];
  }
}

export function saveStylePrefs(styles) {
  localStorage.setItem("grapho_style_prefs", JSON.stringify(styles.slice(0, 12)));
}

export const PREFILL_NOTE =
  "Use references to communicate style, composition, mood or market direction. Grapho creates an original design rather than reproducing the reference.";
